<template>
  <div class="mt10 container" v-loading="isLoading">
    <div class="myMain">
      <div class="relative">
        <el-breadcrumb
          separator-class="el-icon-arrow-right"
          class="containers mb10"
        >
          <el-breadcrumb-item>筑才用户协议</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="container content">
        <div class="title">{{ Title }}</div>
        <div v-html="Body"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetLabelContent } from "@/api/common";

export default {
  name: "",

  data() {
    return {
      Body: "",
      Title: "",
    };
  },
  created() {
    this.getInfo();
  },

  methods: {
    getInfo() {
      GetLabelContent({
        code: "agreement",
      }).then((res) => {
        this.Body = res.data.Body;
        this.Title = res.data.Title;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  background: #fff;
  padding: 25px;
  border-radius: 10px;
  .title {
    text-align: center;
    font-weight: 400;
    font-size: 24px;
    color: #333333;
    margin-bottom: 50px;
  }
}
</style>
